import React from 'react';
import SEO from '../components/SEO';
import Hero from '../components/Hero';
import AboutSection from '../components/AboutSection';
import Services from '../components/Services';
import HotelAmenities from '../components/HotelAmenities';
import Testimonial from '../components/Testimonial';
import LocalAttractions from '../components/LocalAttractions';


const Home = ({ language }) => {
  return (
    <>
      <SEO />
      <Hero language={language} />
      <section className="py-3 bg-light">
        <div className="container">
          <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-3">
            <div>
              <div className="fw-bold" style={{ fontSize: '1.1rem', color: '#1e3a8a' }}>
                {language === 'en' ? 'Guest Rating' : 'የእንግዶች እውቅና'}
              </div>
              <div className="text-muted small">
                {language === 'en'
                  ? 'Based on online guest reviews for Blue Nest Hotel.'
                  : 'በብሉ ኔስት ሆቴል ላይ የተፃፉ የእንግዶች ግምገማዎች መሠረት ያደረገ።'}
              </div>
            </div>
            <div className="d-flex align-items-center gap-3">
              <div className="text-center">
                <div style={{ fontSize: '2rem', fontWeight: 700 }}>3.1</div>

              </div>
              <div>
                <div style={{ color: '#22c55e' }}>★★★☆☆</div>
                <div className="small text-muted">
                  {language === 'en' ? 'Rating from TripAdvisor' : 'ከ TripAdvisor ግምገማ ስክሪንሹት የተወሰደ ደረጃ'}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <AboutSection language={language} />
      <Services language={language} />
      <HotelAmenities language={language} />
      <LocalAttractions language={language} />
      <Testimonial language={language} />
    </>
  );
};

export default Home;